module.exports = __webpack_public_path__ + "static/media/prof.ddd48362.jpg";